import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { AppStoreContext } from "../stores/AppStore";
import { Modal, Button, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

export default observer(function ModalDialog(props) {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();

  const close = e => {
    e.preventDefault();
    appStore.showModal = false;
  };

  return (
    <Modal
      dimmer="blurring"
      open={appStore.showModal}
      onClose={close}
      size="large"
    >
      <Modal.Header>
        {appStore.modalTitle}{" "}
        <div style={{ float: "right" }}>
          <a
            href={appStore.iframeUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <Icon size="small" name="external alternate" />
          </a>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="iframe-wrapper">
          <iframe
            title={appStore.modalTitle}
            src={appStore.iframeUrl}
            frameBorder={0}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close} primary>
          {t("ok")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});
